import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { binarySelectOptions } from '@application/utils';
import { useFormikContext } from 'formik';
import {
  Accordion,
  Button,
  Card,
  ContentPageWrapper,
  InputRadio,
  Modal,
  ModalCloseButton,
  ModalTitle,
  Section,
  SectionText,
} from '..';
import type { SelectOption } from '..';
import * as Styled from './styled';
import type { CookiePreferencesFormValues, CookiePreferencesModalProps } from './types';

export * from './types';

export const CookiePreferencesModal: FC<CookiePreferencesModalProps> = (props) => {
  const { modal, items, onAllowAllClick, onSaveClick } = props;
  const { translate } = useTranslation();
  const yesNoOptions = binarySelectOptions(translate);
  const { values, setFieldValue } = useFormikContext<CookiePreferencesFormValues>();
  return (
    <Modal {...modal}>
      <Card size="medium" isModal>
        <ModalCloseButton modal={modal} />
        <ModalTitle>{translate('cookiePreferences.title')}</ModalTitle>

        <Section centerChildren>
          <SectionText>{translate('cookiePreferences.subtitle')}</SectionText>

          <ContentPageWrapper>
            <Accordion
              maxLabelWidth
              tabs={items.map((item) => ({
                title: (
                  <Styled.CookieCategory>
                    <div className="title">{item.title}</div>
                    <Styled.RadioWrapper className="radio">
                      <InputRadio<boolean>
                        name={item.name}
                        options={yesNoOptions}
                        onSelect={(option: SelectOption<boolean>) => {
                          setFieldValue(item.name, option.value);
                        }}
                        value={values?.[item.name]}
                        preventDefault
                        disabled={item.name === 'necessary'}
                      />
                    </Styled.RadioWrapper>
                  </Styled.CookieCategory>
                ),
                content: (
                  <Styled.AccordionContent dangerouslySetInnerHTML={{ __html: item.content }} />
                ),
              }))}
            />
          </ContentPageWrapper>

          <Styled.ButtonsContainer>
            <Button color="blue" shrink onClick={onAllowAllClick}>
              {translate('cookiePreferences.allowAll')}
            </Button>
            <Button color="white" shrink onClick={onSaveClick} outlined>
              {translate('cookiePreferences.save')}
            </Button>
          </Styled.ButtonsContainer>
        </Section>
      </Card>
    </Modal>
  );
};
